import config from "../../config";
import "./MaintenanceBoard.css";

const DEFAULT_CONTENT = {
  title: "System chwilowo niedostępny",
  message: "Trwa zaplanowana przerwa serwisowa.",
  details:
    "Pracujemy nad aktualizacją systemu. Spróbuj ponownie za jakiś czas.",
};

function MaintenanceBoard() {
  const maintenanceConfig = config.maintenance || {};
  const title = maintenanceConfig.title || DEFAULT_CONTENT.title;
  const message = maintenanceConfig.message || DEFAULT_CONTENT.message;
  const details = maintenanceConfig.details || DEFAULT_CONTENT.details;
  const plannedReturn =
    typeof maintenanceConfig.plannedReturn === "string"
      ? maintenanceConfig.plannedReturn.trim()
      : "";
  const contactEmail =
    typeof maintenanceConfig.contactEmail === "string"
      ? maintenanceConfig.contactEmail.trim()
      : "";

  return (
    <section className="maintenance-board">
      <div className="maintenance-board__shape maintenance-board__shape--left" />
      <div className="maintenance-board__shape maintenance-board__shape--right" />

      <div className="container maintenance-board__container">
        <article className="maintenance-board__card card border-0 shadow-sm">
          <header className="maintenance-board__header">
            <img
              className="maintenance-board__logo"
              src="/assets/images/kig-e7Ti-vgY.png"
              alt="Krajowa Izba Gospodarcza"
            />
            <span className="maintenance-board__label">eCO</span>
          </header>

          <div className="maintenance-board__content">
            <h1 className="maintenance-board__title">{title}</h1>
            <p className="maintenance-board__message">{message}</p>
            <p className="maintenance-board__details">{details}</p>

            {plannedReturn && (
              <div className="maintenance-board__status">
                Planowane przywrócenie: <strong>{plannedReturn}</strong>
              </div>
            )}

            {contactEmail && (
              <p className="maintenance-board__contact">
                Kontakt: <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
              </p>
            )}
          </div>
        </article>
      </div>
    </section>
  );
}

export default MaintenanceBoard;
